/// <reference path="../../node_modules/@types/jquery-validation-unobtrusive/index.d.ts" />

jQuery($ =>
{
    $.validator.setDefaults({
        ignore: ""
    });

    $.validator.addMethod("mustbetrue", (_value, element) => (element as HTMLInputElement).checked);

    $.validator.unobtrusive.adapters.add("mustbetrue",
        (options: any) =>
        {
            setValidationValues(options, "mustbetrue", true);
        });

    function setValidationValues(options: any, ruleName: string, value: any)
    {
        options.rules[ruleName] = value;
        if (options.message)
        {
            options.messages[ruleName] = options.message;
        }
    }
});